import {
  Box,
  Button,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Show, useStyleConfig,
} from '@chakra-ui/react';
import { handleNewExpertiseCheckbox } from '../Expertise/utils';
import { RiAddCircleLine } from 'react-icons/ri';

const AddAnother = ({ props, qObj, style }) => {
  const addAnotherId = 'addAnother_' + qObj.qid;
  const buttonVariant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { buttonVariant});
  return (
    <Show breakpoint="(min-width: 481px)">
      <Box sx={{ ...style.newBox }}>
        &nbsp;Add Another:
        <InputGroup sx={{ ...style.inputGroup }}>
          <Input
            sx={{ ...style.newInput }}
            id={addAnotherId}
            onKeyPress={e => {
              if (e.key === 'Enter') handleNewExpertiseCheckbox(props, qObj);
            }}
          />
          <InputRightElement>
            <Button
              sx={{...buttonStyles.empty}}
              backgroundColor={'#fff'}
              marginLeft={'7rem'}
              border={'1px solid #333'}
              onClick={e => {
                handleNewExpertiseCheckbox(props, qObj);
              }}
            >
              <Icon as={RiAddCircleLine} fontSize={'2rem'} color="GRAY_DARK" />
            </Button>
          </InputRightElement>
        </InputGroup>
      </Box>
    </Show>
  );
};
export default AddAnother;
